import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { WrenchIcon, PaletteIcon, SunIcon, MaximizeIcon, ArrowUpIcon } from 'lucide-react';
const concerns = [{
  icon: WrenchIcon,
  name: 'FINE LINES & WRINKLES',
  desc: 'The laser targets the deeper layers of the skin, stimulating collagen production and promoting skin renewal, which helps reduce the appearance of fine lines and wrinkles over time.'
}, {
  icon: PaletteIcon,
  name: 'UNEVEN SKIN TONE & TEXTURE',
  desc: 'By targeting areas of pigmentation and uneven texture, the laser evens out the skin tone and smoothens its texture, resulting in a more uniform and radiant complexion.'
}, {
  icon: SunIcon,
  name: 'SUN DAMAGE',
  desc: 'The laser energy breaks down excess melanin and pigment in the skin, diminishing the appearance of sunspots, age spots, and other forms of sun damage.'
}, {
  icon: MaximizeIcon,
  name: 'ENLARGED PORES',
  desc: 'The laser treatment helps to tighten and refine the skin, reducing the size of enlarged pores and improving overall skin texture for a smoother appearance.'
}, {
  icon: ArrowUpIcon,
  name: 'SKIN LAXITY',
  desc: "By promoting collagen remodeling and tightening the skin's underlying structures, the laser improves skin firmness and elasticity, resulting in a more lifted and youthful appearance."
}];
export function HLConcerns() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-1373">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-1374">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-1375">
          <h2 className="text-[28px] lg:text-[44px] uppercase text-white leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-1376">
            COSMETIC CONCERNS ADDRESSED
          </h2>

          <p className="font-serif italic text-[#B0B0B0] text-[17px] leading-[1.7] max-w-[700px] mb-6" data-id="element-1377">
            The Halo Skin Resurfacing Laser effectively addresses a range of
            cosmetic concerns, including:
          </p>

          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-1378"></div>
        </AnimateOnScroll>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6" data-id="element-1379">
          {concerns.map((concern, index) => <AnimateOnScroll key={index} delay={index * 80} data-id="element-1380">
              <div className="bg-[#111111] p-8 text-center h-full group hover:shadow-[0_0_20px_rgba(255,20,147,0.1)] transition-shadow duration-300" data-id="element-1381">
                <concern.icon size={40} strokeWidth={1.5} className="text-[#FF1493] mx-auto mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-1382" />
                <h3 className="text-white font-bold text-[14px] uppercase font-[Poppins,_sans-serif] mb-3 tracking-wide" data-id="element-1383">
                  {concern.name}
                </h3>
                <p className="text-[#B0B0B0] text-[13px] leading-[1.6] font-body" data-id="element-1384">
                  {concern.desc}
                </p>
              </div>
            </AnimateOnScroll>)}
        </div>
      </div>
    </section>;
}